import type { WorkspaceKey } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'
import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'

import { useWorkspaceStatus } from '../../uiModels/workspace/useWorkspaceStatus'
import { isEqualWorkspace } from '../../workspace/helpers'
import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'
import { Attribute } from '../attribute/Attribute'

type Props = {
  isShowingIcon: boolean
  workspaceKey: WorkspaceKey
  className?: string
}

export const WorkspaceName = ({
  isShowingIcon,
  workspaceKey,
  className,
}: Props) => {
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const isActive = isEqualWorkspace(workspaceKey, currentWorkspaceKey)
  const status = useWorkspaceStatus(workspaceKey)
  const translate = useTranslate()

  return (
    <Attribute
      isFaded={false}
      className={cx(
        'flex gap-x-2 overflow-hidden text-ellipsis text-nowrap items-center rounded-md font-medium',
        {
          'bg-draft-600 dark:bg-draft-400 text-amaze-inkBright': isActive,
          'bg-transparent!': !isActive,
        },
        className,
      )}
      isShowingIndicator={status === 'outOfSync'}
      indicatorLabel={translate('branchesTree.status.base.workspaceOutOfSync')}
    >
      {isShowingIcon && <Icon name="Briefcase" />}
      {workspaceKey.name}
    </Attribute>
  )
}
